var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.621094,
    width: 60,
    height: 60,
    rx: 30,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0137 30.7461C44.0137 31.625 43.2812 32.3086 42.4512 32.3086H40.8887L40.9375 40.1211C40.9375 40.2676 40.9375 40.4141 40.9375 40.5117V41.293C40.9375 42.416 40.0586 43.2461 38.9844 43.2461H38.2031C38.1055 43.2461 38.0566 43.2461 38.0078 43.2461C37.959 43.2461 37.8613 43.2461 37.8125 43.2461H35.0781C33.9551 43.2461 33.125 42.416 33.125 41.293V36.9961C33.125 36.166 32.3926 35.4336 31.5625 35.4336H28.4375C27.5586 35.4336 26.875 36.166 26.875 36.9961V41.293C26.875 42.416 25.9961 43.2461 24.9219 43.2461H22.1875C22.0898 43.2461 22.041 43.2461 21.9434 43.2461C21.8945 43.2461 21.8457 43.2461 21.7969 43.2461H21.0156C19.8926 43.2461 19.0625 42.416 19.0625 41.293V35.8242C19.0625 35.8242 19.0625 35.7754 19.0625 35.7266V32.3086H17.5C16.6211 32.3086 15.9375 31.625 15.9375 30.7461C15.9375 30.3066 16.084 29.916 16.4258 29.5742L28.9258 18.6855C29.2676 18.3438 29.6582 18.2461 30 18.2461C30.3418 18.2461 30.7324 18.3926 31.0254 18.6367L43.4766 29.5742C43.8672 29.916 44.0625 30.3066 44.0137 30.7461Z",
    fill: "url(#paint0_linear_1101_45547)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_45547",
    x1: 24.9673,
    y1: 41.1211,
    x2: 38.4055,
    y2: 22.5635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeButton);
export default __webpack_public_path__ + "static/media/homeButton.f3380b9615164b4088aca108252b0912.svg";
export { ForwardRef as ReactComponent };